import { useMutation } from '@apollo/client';

import LearnerObjectUpdateLastIndicatedUnsureRolesAt from 'bundles/onboarding-common/queries/LearnerObjectUpdateLastIndicatedUnsureRolesAt.graphql';
import type {
  LearnerObject_UpdateLastIndicatedUnsureRolesAtMutation as LearnerObjectUpdateLastIndicatedUnsureRolesAtMutationType,
  LearnerObject_UpdateLastIndicatedUnsureRolesAtMutationVariables,
} from 'bundles/onboarding-common/queries/__generated__/LearnerObjectUpdateLastIndicatedUnsureRolesAt';

const useLearnerObjectUpdateLastIndicatedUnsureRolesAt = () => {
  const [updateLastIndicatedUnsureRolesAtMutation] = useMutation<
    LearnerObjectUpdateLastIndicatedUnsureRolesAtMutationType,
    LearnerObject_UpdateLastIndicatedUnsureRolesAtMutationVariables
  >(LearnerObjectUpdateLastIndicatedUnsureRolesAt, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const updateLastIndicatedUnsureRolesAt = async (timestamp: string) => {
    const variables: LearnerObject_UpdateLastIndicatedUnsureRolesAtMutationVariables = {
      input: {
        lastIndicatedUnsureRolesAt: timestamp,
      },
    };

    const { errors, data } = await updateLastIndicatedUnsureRolesAtMutation({
      variables,
    });

    if (errors) {
      return { success: false, errors: errors.map((error) => error.message) };
    }

    if (
      data?.LearnerObject_UpdateLastIndicatedUnsureRolesAt.__typename ===
      'LearnerObject_UpdateLastIndicatedUnsureRolesAtResultError'
    ) {
      return {
        success: false,
        errors: [data.LearnerObject_UpdateLastIndicatedUnsureRolesAt.message],
      };
    }

    return { success: true, errors: [] };
  };

  return {
    updateLastIndicatedUnsureRolesAt,
  };
};

export default useLearnerObjectUpdateLastIndicatedUnsureRolesAt;
